import { TimelineFilingRow } from "store/apis/filingsTimeline";

/** The track has room for a few characters only, so prefer the short name. */
export const getFilingShortName = (filing: TimelineFilingRow): string =>
  filing.short_name || filing.name;
